import React from "react";
import i18n from "../../../../constants/i18n";
import {
  DEVELOPER_FLAGGED_CONNECTIONS_DETAILS_HEADERS,
  DEVELOPER_FLAGGED_CONNECTIONS_HISTORY_HEADERS
} from "../../../../constants/table-custom-headers/Developers";
import getFlaggedConnectionStore from "../../../../stores/developer-store/flagged-connections-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const FlaggedConnectionsDashboardData = withLiteObserverAndTheme(() => {
  const flaggedConnectionData =
    getFlaggedConnectionStore().flaggedConnectionsData.get();
  const flaggedConnectionDetails =
    getFlaggedConnectionStore().flaggedConnectionsDetails.get();

  return (
    <React.Fragment>
      <Et3Table
        columns={DEVELOPER_FLAGGED_CONNECTIONS_HISTORY_HEADERS}
        rows={flaggedConnectionData}
        title={i18n.get("FLAGGED_CONNECTIONS_HISTORY")}
        shouldBeFlagged={false}
        titleKey={"FLAGGED_CONNECTIONS_HISTORY"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_FLAGGED_CONNECTIONS_DETAILS_HEADERS}
        rows={flaggedConnectionDetails}
        title={i18n.get("FLAGGED_CONNECTIONS_DETAILS")}
        shouldBeFlagged={false}
        titleKey={"FLAGGED_CONNECTIONS_DETAILS"}
      />
    </React.Fragment>
  );
});

export default FlaggedConnectionsDashboardData;
